import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const RevenueDetails = {
	name: NAME,
	apiProvider,
	router,
};
